import template from './deregistration-with-card.html';

export class DeregistrationWithCardController {
  constructor($log, $mdDialog, access) {
    'ngInject';
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.cardId = '';
    this._activeStep = 1;
    this.access = access;
    this.students = null;
  }

  get activeStep() {
    return this._activeStep;
  }

  closeDialog() {
    this.$mdDialog.cancel();
  }

  nextStep() {
    this._activeStep += 1;
  }

  setStudents(students) {
    this.students = students;
  }
}

export const DeregistrationWithCard = {
  bindings: {
  },
  controller: DeregistrationWithCardController,
  template
};
